"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFontFamily = exports.fontFamily = void 0;
var fontFamily = {
  main: 'Montserrat'
};
exports.fontFamily = fontFamily;
var getFontFamily = function getFontFamily(theme) {
  var fontFamilies = theme.fontFamilies;
  return fontFamilies;
};
exports.getFontFamily = getFontFamily;